<template>
  <div>
    <h3
      class="transfer-title insurance-title font-21 noto-semibold"
      v-if="
        _.get(itemData, 'conf.header.title') &&
        _.get(itemData, 'conf.useHeader') == 1
      "
    >
      {{ _.get(itemData, "conf.header.title") }}
    </h3>

    <template v-for="(slide, index) in itemData.data">
      <div
        class="app-link-box high br-12"
        :key="index"
        style="margin-bottom: 25px"
      >
        <div class="img-box">
          <picture>
            <source
              media="(max-width: 767px)"
              :srcset="_.get(itemData, 'cover_image.0.devices.mobile')"
            />
            <source
              media="(max-width: 1023px)"
              :srcset="_.get(itemData, 'cover_image.0.devices.tablet')"
            />
            <img
              v-bind:src="_.get(slide, 'cover_image.0.devices.desktop')"
              alt=""
              class="img-absolute br-12"
            />
          </picture>

          <div class="gradient br-12"></div>
          <div class="box-content">
            <h3 class="white font-34 noto-semibold">
              {{ _.get(slide, "title") }}
            </h3>
            <p class="white">{{ _.get(slide, "teaser") }}</p>

            <SmartButton
              :cssclass="'btn sub bg-white'"
              :itemData="_.get(slide, 'smartbuttons.0')"
              v-if="_.get(slide, 'smartbuttons.0')"
            />
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import SmartButton from "./modules/SmartButton";

export default {
  props: ["itemData", "titleData", "noBg"],
  components: { SmartButton },
};
</script>
